import { useNavigate } from "react-router-dom";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../../components/actionMenu/ActionMenu";
import { useAppDispatch } from "../../../../../redux/hooks";
import { setFleetFeatureData } from "../../../../../redux/reducer/fleet.reducer";
import { FleetFeaturesDataInterface } from "../../../../../redux/interfaces/fleet.interface";
import { fetchDeleteFeature } from "../../../../../redux/api/fleet.api";
import { crudRoutes, fleetRoutes } from "../../../../../router/routesConstants";
import usePermissions from "../../../../../router/usePermissions";
import userRoles from "../../../../../constants/userRoles";

function FleetFeaturesActionButton({
  crudData,
  itemId,
}: {
  itemId: string;
  crudData: FleetFeaturesDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthorized } = usePermissions();

  const {
    CAR_FEATURE_DELETE_PERMISSION,
    CAR_FEATURE_EDIT_PERMISSION,
    CAR_FEATURE_DOCUMENTS_DISPLAY_PERMISSION,
  } = {
    CAR_FEATURE_EDIT_PERMISSION: isAuthorized(userRoles.CAR_FEATURE_EDIT),
    CAR_FEATURE_DELETE_PERMISSION: isAuthorized(userRoles.CAR_FEATURE_DELETE),
    CAR_FEATURE_DOCUMENTS_DISPLAY_PERMISSION: isAuthorized(
      userRoles.CAR_FEATURE_DOCUMENTS_DISPLAY,
    ),
  };

  const handleEdit = () => {
    dispatch(setFleetFeatureData(crudData));
    navigate(
      `${crudRoutes.edit}?nrauto=${crudData.nrauto}&tip=${crudData.tip}`,
    );
  };

  const handleGoToDocuments = () => {
    navigate(
      `${itemId}/${fleetRoutes.documents}?nrauto=${crudData.nrauto}&denumireEchipament=${crudData.denumire}&tip=${crudData.tip}`,
    );
  };

  const handleDelete = () => {
    dispatch(fetchDeleteFeature({ id: itemId, carId: crudData.id_auto }));
  };

  const items: ActionMenuItem[] = [
    {
      id: "edit",
      label: "Editeaza caracteristici echipament",
      section: "manage",
      icon: "EDIT",
      tooltip: "Deschide editarea caracteristicilor echipamentului.",
      hidden: !CAR_FEATURE_EDIT_PERMISSION,
      onClick: handleEdit,
    },
    {
      id: "documents",
      label: "Documente echipament calitate",
      section: "browse",
      icon: "DOCUMENTS",
      tooltip: "Afiseaza documentele echipamentului de calitate.",
      hidden: !CAR_FEATURE_DOCUMENTS_DISPLAY_PERMISSION,
      onClick: handleGoToDocuments,
    },
    {
      id: "delete",
      label: "Sterge caracteristicile echipamentului",
      section: "danger",
      icon: "DELETE",
      color: "error",
      tooltip: "Sterge caracteristicile echipamentului, dupa confirmare.",
      hidden: !CAR_FEATURE_DELETE_PERMISSION,
      withConfirmationModal: {
        modalTitle: `Doriti sa stergeti: ${crudData.denumire}?`,
        modalLeftButtonColor: "inherit",
        modalRightButtonOnClick: handleDelete,
        modalRightButtonText: "Sterge",
        modalRightButtonColor: "error",
        modalLeftButtonText: "Anuleaza",
      },
    },
  ];

  return (
    <ActionMenu
      items={items}
      title={crudData.denumire}
      ariaLabel={`Actiuni pentru echipamentul ${crudData.denumire}`}
    />
  );
}

export default FleetFeaturesActionButton;
